import React from 'react';
import { getCommonStyles } from '../styles/commonStyles';

interface ActionButtonsProps {
  isDarkTheme?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  submitLoading?: boolean;
  submitDisabled?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isDarkTheme,
  onCancel,
  onSubmit,
  submitLoading = false,
  submitDisabled = false
}) => {
  const commonStyles = getCommonStyles(isDarkTheme || false);

  return (
    <div style={{ marginTop: "20px", display: "flex", gap: "10px" }} data-tour="action-buttons">
      <button
        style={commonStyles.button}
        onClick={onCancel}
        data-tour="cancel-button"
      >
        Cancel
      </button>
      <button
        style={{
          ...commonStyles.button,
          opacity: submitLoading || submitDisabled ? 0.5 : 1,
          cursor: submitLoading || submitDisabled ? 'not-allowed' : 'pointer',
          backgroundColor: submitDisabled ? (isDarkTheme ? '#555' : '#ccc') : commonStyles.button.backgroundColor
        }}
        onClick={submitDisabled ? undefined : onSubmit}
        disabled={submitLoading || submitDisabled}
        data-tour="submit-button"
      >
        {submitLoading ? (
          <>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid #f3f3f3",
                  borderTop: "2px solid #007bff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite"
                }}
              />
              Submitting...
            </div>
          </>
        ) : (
          'Submit'
        )}
      </button>
    </div>
  );
};

export default ActionButtons;